import conf from './Config';

const frontendProjectURL = (id) => `${conf.FRONTEND_URL}/project/${id}`;

function normalizeMatchPath(obj) {
	return obj.props.match.path.replace(/[/]$/,'');
}

export { 
	normalizeMatchPath
	,frontendProjectURL
};
